module.exports = __webpack_public_path__ + "static/checkout-7e0ddd3a32b28a483751b5546faca617.png";